import { useContext } from 'react';
import { AuthContext } from '../AuthContext';
import authService from '../services/authService';

/**
 * Custom hook for login functionality
 * Handles login API call and updates auth context state
 * @returns {Object} { login, isLoading, error }
 */
export const useLogin = () => {
  const { setUser, setRoles, setSelectedRole, setLoading, loading } = useContext(AuthContext);

  const login = async (email, password) => {
    try {
      setLoading(true);
      const result = await authService.login(email, password);

      if (result.success) {
        const { user: userData } = result.data;

        // Store authentication data (tokens and user info)
        authService.storeAuthData(result.data);

        // Extract and store roles - try multiple possible locations
        let roles = result.data.roles || result.data.user?.roles || [];
        setRoles(roles);
        const defaultRole = authService.getDefaultRole(roles);
        
        if (defaultRole) {
          authService.storeSelectedRole(defaultRole);
          setSelectedRole(defaultRole);
        }

        // Set user in context
        const userInfo = userData || { email, name: email.split('@')[0] };
        setUser(userInfo);

        return { success: true, roles, selectedRole: defaultRole };
      } else {
        return { success: false, error: result.error };
      }
    } catch (error) {
      console.error("Login error:", error);
      return { success: false, error: "An unexpected error occurred." };
    } finally {
      setLoading(false);
    }
  };

  return { login, isLoading: loading };
};
